import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignUpForm from "../../components/auth/SignUpForm";

export default function SignUp() {
  return (
    <>
      <PageMeta
        title="Sign Up - Bullet Delivery"
        description="Create your Bullet Delivery account to start managing deliveries and logistics. Join our comprehensive delivery platform with advanced role-based access control and real-time tracking capabilities."
        keywords="sign up, register, delivery management, logistics platform, account creation"
      />
      <AuthLayout>
        <SignUpForm />
      </AuthLayout>
    </>
  );
}
